module.exports = __webpack_public_path__ + "static/img/30005 (3).a2fb27f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30005 (3).webp
// module id = IZyO
// module chunks = 14